
import Vue from "vue";
import store from "@/store";
import AppWarning from "../../UI/AppWarning.vue";
import { convertFullDate } from "@/utils/date";
import { convertToPersian, separateDigits } from "@/utils/string";

export default Vue.extend({
  name: "ProfileWallet",
  components: {
    AppWarning,
  },
  computed: {
    transactions() {
      return store.state.panel.transactions;
    },
  },
  created() {
    if (!store.state.panel.transactions.length) {
      setTimeout(function () {
        store.dispatch("panel/getTransactions");
      }, 1000);
    }
  },
  methods: {
    convertFullDate,
    convertToPersian,
    separateDigits,
  },
});
